import { useEffect, useMemo, useCallback, useRef } from 'react';
import getModels from '../../api/cars/getModels';
import createModel from '../../api/cars/createModel';
import Select from '../Select/Select';
import usePaginatedSelect from '../../hooks/usePaginatedSelect';
import DictionaryNameModal from '../Modal/DictionaryNameModal';
import useDictionaryCreator from './useDictionaryCreator';

const extractItems = (res) => res.data.models;
const formatOption = (item) => ({ value: item.id, label: item.name });

/**
 * @param {boolean} used â Ð±/Ñ-Ð¿ÑÐ¾ÑÐµÑÑ: Ð¾Ð±ÑÑÐ½ÑÐµ Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð¿Ð»ÑÑ Ð·Ð°Ð²ÐµÐ´ÑÐ½Ð½ÑÐµ Ð¿Ð¾Ð´ Ð±/Ñ,
 * Ñ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ Ð·Ð°Ð²ÐµÑÑÐ¸ Ð½Ð¾Ð²ÑÑ Ð¿ÑÑÐ¼Ð¾ Ð·Ð´ÐµÑÑ.
 */
const SelectModels = ({
  handleSetSelect,
  handleSetState,
  params,
  style,
  dependantValue,
  dependencyAccessor = (obj) => obj,
  onChangeCustom,
  used,
  creatable,
  ...props
}) => {
  const depValue = useMemo(() => dependencyAccessor(dependantValue), [dependantValue, dependencyAccessor]);

  const fetchFn = useCallback(
    (page) => getModels({ markId: depValue, page, used: used || undefined }),
    [depValue, used]
  );

  const { data, isLoading, loadMore, reset } = usePaginatedSelect({ fetchFn, extractItems, formatOption });

  const onFocus = useCallback(() => {
    if (!depValue) return;
    loadMore();
  }, [depValue, loadMore]);

  const create = useCallback(
    async (name) => {
      if (!depValue) throw new Error('Ð¡Ð½Ð°ÑÐ°Ð»Ð° Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð¼Ð°ÑÐºÑ');
      // ÐÐ¾Ð½ÑÑÐ¾Ð»Ð»ÐµÑ (CarsController.createModel) Ð½Ð° ÑÑÐ¿ÐµÑÐµ Ð¾ÑÐ´Ð°ÑÑ { markId },
      // Ð² ÐºÐ¾ÑÐ¾ÑÐ¾Ð¼ Ð»ÐµÐ¶Ð¸Ñ id Ð¸Ð¼ÐµÐ½Ð½Ð¾ ÑÐ¾Ð·Ð´Ð°Ð½Ð½Ð¾Ð¹ Ð¼Ð¾Ð´ÐµÐ»Ð¸.
      const res = await createModel({ markId: depValue, name, used: !!used });
      const id = Number(res?.data?.markId);
      if (!id) throw new Error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ');
      return { value: id, label: name };
    },
    [depValue, used]
  );

  const { extraOptions, selectProps, modalProps } = useDictionaryCreator({
    // ÐÐµÐ· Ð¼Ð°ÑÐºÐ¸ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð·Ð°Ð²Ð¾Ð´Ð¸ÑÑ Ð½Ðµ Ðº ÑÐµÐ¼Ñ â ÐºÐ½Ð¾Ð¿ÐºÑ Ð² ÑÐ¿Ð¸ÑÐºÐµ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼.
    enabled: Boolean((creatable ?? used) && depValue),
    kind: 'model',
    create,
    onChange: props?.onChange,
    onChangeCustom: (val) => onChangeCustom && onChangeCustom(val, dependantValue),
    resetKey: depValue,
    context: dependantValue?.label && `ÐÐ°ÑÐºÐ°: ${dependantValue.label}`,
  });

  const options = useMemo(() => [...extraOptions, ...data], [extraOptions, data]);

  const isFirstRun = useRef(true);

  useEffect(() => {
    reset();
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    if (props?.onChange) {
      props.onChange(null);
    }
  }, [depValue]);

  return (
    <>
      <Select
        handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
        handleSetState={handleSetState}
        options={options}
        title={'ÐÐ¾Ð´ÐµÐ»Ñ'}
        placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
        onFocus={onFocus}
        style={style}
        isLoading={isLoading}
        onChangeCustom={(val) => {
          if (onChangeCustom) {
            onChangeCustom(val, dependantValue);
          }
        }}
        {...props}
        {...selectProps}
      />
      {selectProps && <DictionaryNameModal {...modalProps} />}
    </>
  );
};

export default SelectModels;
